import { environment } from '@tsq-web/environment';

export function getEnvBasedAssetsPath(path: string): string {
  return 'assets' in environment ? `${(environment as Record<string, unknown>).assets}${path}` : path;
}
